import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'addressCarry'
})
export class AddressCarryPipe implements PipeTransform
{
    transform(value: string): string
    {
        const valueLength = value.length;
        const center = Math.round(valueLength / 2);

        return value.slice(0, center) + '<br/>' + value.slice(center);
    }
}
